import { CurrentUser, PublicUser } from "@/types/user"
import { cn } from "cn"

import { useAppSelector } from "@/lib/storage/hooks"
import { selectUser, selectUserIsAnonymous } from "@/lib/storage/user-slice"
import { blank } from "@/lib/utils/presence"

export function UserHandle({
  user,
  // showVerified = false,
  showAt = true,
  className,
}: {
  user?: CurrentUser | PublicUser
  showVerified?: boolean
  showAt?: boolean
  className?: string
}) {
  const isAnonymous = useAppSelector(selectUserIsAnonymous)
  const currUser = useAppSelector(selectUser)

  // If anonymous user and we did not pass in other user.
  // If we passed in other user, we want to display that (i.e. inspiration's owner)
  if (isAnonymous && blank(user)) return null

  const handleUser = user || currUser
  // const emailVerified =
  //   "email_validated" in handleUser ? handleUser.email_validated : false

  return !user && currUser.provider === "" ? (
    <span className={cn("flex", className)}>&nbsp;</span>
  ) : (
    <span className={cn("flex items-center gap-[.0625em]", className)}>
      <span className="no-translate truncate">
        <span className="contents">{showAt && "@"}</span>
        {handleUser.handle}
      </span>
      {/* Don't show verified for now. It means something different as in "trusted" */}
      {/* {showVerified && emailVerified && (
        <IconVerify className="text-[1.25em] text-primary" />
      )} */}
    </span>
  )
}
